var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi_9055381",
    enableBackground: "new 0 0 512 512",
    height: 20,
    viewBox: "0 0 512 512",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000054249664156751987770000000529649552003164843_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m141 104v-28.1c0-12.5-10.1-22.6-22.6-22.6-4.7 0-9.3 1.5-13.2 4.2l-93.1 67.2c-10.1 7.4-12.4 21.5-5.1 31.6 1.4 2 3.1 3.7 5.1 5.1l93.2 67.2c10.1 7.3 24.2 5 31.5-5.2 2.8-3.8 4.2-8.4 4.2-13.2v-26.2h193.7c53.7 0 97.3 43.6 97.3 97.3 0 53.8-43.6 97.3-97.3 97.3h-312.9c-12 0-21.8 9.8-21.8 21.8v36.5c0 12 9.8 21.8 21.8 21.8h312.9c97.9 0 177.3-79.4 177.3-177.3 0-97.9-79.4-177.3-177.3-177.3h-193.7z",
    fill: "#8BA4BF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefund);
export default __webpack_public_path__ + "static/media/Refund.40dd640d1e9500c07606e87372a0d692.svg";
export { ForwardRef as ReactComponent };